export const chipMaxWidth = 200
